import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { FeatherModule } from 'angular-feather';
import { MessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BranchService } from 'src/app/services/branches.service';
import { AddBranchComponent } from '../add-branch/add-branch.component';
import { EditBranchComponent } from '../edit-branch/edit-branch.component';
import { BranchesInterface } from 'src/app/util/uiNecessaryInterface';
import { PaginatorModule } from "primeng/paginator";



@Component({
  selector: 'app-all-branches',
  standalone: true,
  imports: [CommonModule, SharedModule, ConfirmDialogModule, ButtonModule, ReactiveFormsModule, TagModule, ProgressBarModule, TableModule, RouterModule, FormsModule, FeatherModule, ConfirmPopupModule, AddBranchComponent, EditBranchComponent, PaginatorModule],
  providers: [ConfirmationService],
  templateUrl: './all-branches.component.html',
  styleUrl: './all-branches.component.scss'
})
export class AllBranchesComponent {

  breadCrumbItems!: Array<{}>;
  filteredRequests: any;
  searchValue: string = "";
  branchesList: BranchesInterface[] = [];
  branchId: any;
  viewedBranch: any;

  private modalService = inject(NgbModal);
  private branchService = inject(BranchService);
  private toastr = inject(ToastrService);
  private confirmationService = inject(ConfirmationService);
  private ngxLoader = inject(NgxUiLoaderService);

  /* pagination part */
  first: number = 0;
  page: number = 1
  rows: number = 15;
  pageSize: number = 15;
  totalRecords!: number;

  @ViewChild(AddBranchComponent) addBranch!: AddBranchComponent;
  @ViewChild(EditBranchComponent) editBranch!: EditBranchComponent;

  private searchDebounce!: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Dashboard" },
      { label: "Branches", active: true },
    ];
    this.getAllBranches(this.page, this.pageSize, this.searchValue.trim());
  }



  onPageChange(event: any) {
    const requestedPage = event.first / event.rows + 1;
    const maxPage = Math.ceil(this.totalRecords / event.rows);

    const page = Math.min(requestedPage, maxPage);

    this.first = (page - 1) * event.rows;
    this.rows = event.rows;

    this.getAllBranches(page, this.rows, this.searchValue.trim());
  }


  getAllBranches(pageNumber: number, pageSize: number, firstName?: string) {
    this.ngxLoader.start();
    this.branchService.findAll({ ppg: pageSize, page: pageNumber, search: firstName?.trim() }).subscribe((resp: any) => {

      this.branchesList = resp.data;
      this.totalRecords = resp.pagination.meta.total;

      const maxPage = Math.ceil(this.totalRecords / this.rows);
      if (this.page > maxPage) {
        this.page = maxPage;
        this.first = (maxPage - 1) * this.rows;
      }
      this.ngxLoader.stop();
    });
  }

  /* filter by employee first name */
  filterRequests(): void {
    clearTimeout(this.searchDebounce);

    this.searchDebounce = setTimeout(() => {
      const search = this.searchValue.trim();
      this.getAllBranches(this.page, this.pageSize, search);
    }, 700);
  }

  reloadBranchesFindAll() {
    this.getAllBranches(this.page, this.pageSize, this.searchValue.trim());
  }
  reloadBranchesGetAll() {
    this.getAllBranches(this.page, this.pageSize, this.searchValue.trim());
  }

  addNewCreateBranch() {
    this.addBranch.addBranchModal();
  }

  updateBranchModal(request: BranchesInterface) {
    this.editBranch.editBranchModalOpen(request);
  }

  openBranchViewModel(content: any, id: number) {
    this.viewedBranch = this.branchesList.find((item: any) => item.id === id);
    this.modalService.open(content);
  }



  deleteBranch(event: Event, id: any, name: any) {
    this.branchId = id;
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      header: 'Are you sure?',
      message: `${name}`,
      icon: 'pi pi-question',
      accept: () => {
        this.accept();
      },
      reject: () => {
        this.reject();
      }
    });
  }



  accept(): void {
    this.ngxLoader.start();
    this.branchService.delete(this.branchId).subscribe({
      next: (response: ApiResponse) => {
        this.getAllBranches(this.page, this.pageSize, this.searchValue.trim());
        this.toastr.success('Branch Deleted', 'Success');
        this.ngxLoader.stop();
      },
      error: (e) => {
        // this.getAllFiles(this.parent_id, this.category_name);
        // this.toastr.error('Something Went wrong', 'error');
        this.ngxLoader.stop();
      },
    });
    this.confirmationService.close();
  }

  reject(): void {
    this.confirmationService.close();
  }

}
